import React, {FC} from 'react';
import {Alert} from '@material-ui/lab';
import {withStyles} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog, {DialogProps} from '@material-ui/core/Dialog';
import {withLocalization} from 'epic-localization/src/context/LocalizationContext';

const CODES = {
    title: 'epic.affiliate.fortnite_games.limit_warning.title',
    description: 'epic.affiliate.fortnite_games.limit_warning.description',
    alert: 'epic.affiliate.fortnite_games.limit_warning.alert',
    confirm: 'epic.affiliate.fortnite_games.limit_warning.confirm',
    cancel: 'epic.affiliate.common.cancel'
};

export const StyledDialog = withStyles({
    paper: {
        maxWidth: '480px'
    }
})(Dialog);

const StyledContent = withStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',

        '&> h2, p, > div:first-of-type': {
            marginBottom: theme.spacing(8)
        },

        '&> div:nth-of-type(2)': {
            marginBottom: theme.spacing(4)
        }
    }
}))(DialogContent);

export interface WarningModalProps extends DialogProps {
    limit: number;
    onConfirm: () => void;
    onCancel: () => void;
    getMessage: (code: string, args?: any[]) => string;
}

const LegendsWarningModal: FC<WarningModalProps> = ({
    limit,
    onConfirm,
    onCancel,
    getMessage,
    ...props
}: WarningModalProps) => {
    return (
        <StyledDialog {...props}>
            <StyledContent>
                <Typography variant="h2" color="textPrimary" align="center">
                    {getMessage(CODES.title)}
                </Typography>
                <Typography variant="body1" color="textSecondary" align="center">
                    {getMessage(CODES.description, [limit])}
                </Typography>
                <Alert severity="warning" variant="standard">
                    {getMessage(CODES.alert)}
                </Alert>
                <Button size="large" color="primary" component="div" onClick={onConfirm}>
                    {getMessage(CODES.confirm)}
                </Button>
                <Button size="large" color="secondary" component="div" onClick={onCancel}>
                    {getMessage(CODES.cancel)}
                </Button>
            </StyledContent>
        </StyledDialog>
    );
};

export default withLocalization(LegendsWarningModal);
